import { render, staticRenderFns } from "./StockAvailability.vue?vue&type=template&id=151386f0&scoped=true&"
import script from "./StockAvailability.vue?vue&type=script&lang=js&"
export * from "./StockAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151386f0",
  null
  
)

export default component.exports